import PlusIcon from "app/components/Icons/PlusIcon";
import { formatLabel } from "app/containers/Features/containers/Boards/helpers";
import { GroupByTypeEnum } from "app/containers/Features/containers/Boards/types";
import React from "react";

interface Props {
  groupBy: GroupByTypeEnum;
  onAddNewGroup: () => void;
  hasDataVisible: boolean;
}
export default function InfoText({
  groupBy,
  onAddNewGroup,
  hasDataVisible,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      {groupBy === GroupByTypeEnum.CUSTOM_TITLES && (
        <button
          className="flex items-center justify-start px-4 py-3 text-secondary text-sm font-medium leading-[21px] capitalize hover:bg-gray-400 border-b border-gray-100 "
          onClick={onAddNewGroup}
        >
          <PlusIcon color="#79808A" size={20} />
          <span> New group</span>
        </button>
      )}
      <div className="flex flex-col items-start justify-start px-4 py-3">
        <span className="text-secondary text-sm font-medium">
          Hidden group(s)
        </span>
        <span className="text-[10px] font-normal text-secondary leading-[13px]">
          {hasDataVisible
            ? `By clicking on ${formatLabel(
                groupBy,
              )} it will be returned to the board`
            : "There are no hidden group(s)"}
        </span>
      </div>
    </div>
  );
}
